import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContactEmergencyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"contact_emergency"}/>
}
